<template>
    <div class="qksm">
        <div class="nogap">
            <p><b>（三）2022年预算安排情况</b></p>
            <p>
                2022年{{$store.state.divData.divname}}（系统）预算安排{{isMoney(T4.总计)}}万元，其中不含政府投资项目的预算为{{isMoney(T4.总计不含)}}万元，与上年同口径预算增长{{isMoney(T4.占比*100)}}%（详见附表四）。具体有：
            </p>
            <p v-for="(item, idx) in T4.项目">
                {{idx+1}}.{{item.name}}安排{{isMoney(item.value[0].value)}}万元，
                <template v-if="num(item.value[0].value)==0">
                    上年安排0万元，与上年预算数持平
                </template>
                <template v-else>
                    比上年预算数{{item.value[0].ratio<0 ? "减" : "增"}}{{isMoney(Math.abs(item.value[0].ratio*100))}}%
                </template>{{idx==T4.项目.length-1?'。':'；'}}
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm3",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        components: {
            reason,
        },
        props: {
            T4: {
                type: Object,
                default: "",
            },
        },
    };

</script>